'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reduxForm = require('redux-form');

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _forms = require('metadata/forms');

var _forms2 = require('utils/forms');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    PersonalInformation: {
        displayName: 'PersonalInformation'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/RequirementSet/forms/PersonalInformation.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var jacketSizeInfoBox = _react3.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formPersonalInformation.jacketSizeStub',
    defaultMessage: '{stubText}',
    values: {
        stubText: _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
                'h4',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formPersonalInformation.jacketSizeStubTitle',
                    defaultMessage: 'Expedition Parka Size' })
            ),
            _react3.default.createElement(
                'p',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formPersonalInformation.jacketSizeStubText',
                    defaultMessage: 'All passengers get their very own high-performance parka, equipped for handling the polar regions, to wear while on the trip and to take home at the end of the cruise.\n\nThe fitting happens on day 1 on board. If the size you requested in advance does not fit, you will have the opportunity to change this without any complications.' })
            )
        )
    } });

var bootsSizeInfoBox = _react3.default.createElement(
    'div',
    null,
    _react3.default.createElement(
        'h4',
        null,
        _react3.default.createElement(_reactIntl.FormattedMessage, {
            id: 'formPersonalInformation.bootsSizeInfoTitle',
            defaultMessage: 'Bog Boots Size' })
    ),
    _react3.default.createElement(
        'p',
        null,
        _react3.default.createElement(_reactIntl.FormattedMessage, {
            id: 'formPersonalInformation.bootsSizeInfoText1',
            defaultMessage: 'All passengers get their very own bog boots, equipped for handling the polar regions, to wear while participating in landings and zodiac excursions. Bog boots will be placed in your cabin upon arrival to the Expedition.' })
    ),
    _react3.default.createElement(
        'p',
        null,
        _react3.default.createElement(_reactIntl.FormattedMessage, {
            id: 'formPersonalInformation.bootsSizeInfoText2',
            defaultMessage: 'When selecting your size, we highly recommend sizing up to accommodate thick socks. Because Bogs are built on unisex European molds, finding your standard EU size in the drop-down menu is the most accurate way to ensure a great fit.' })
    ),
    _react3.default.createElement(
        'p',
        null,
        _react3.default.createElement(_reactIntl.FormattedMessage, {
            id: 'formPersonalInformation.bootsSizeInfoText3',
            defaultMessage: 'If you wear a US Women\'s 13 or larger, simply select the corresponding EU or US Men\'s size, as the boots are structurally identical. If the size you requested in advance does not fit, you will have the opportunity to change this without any complications onboard the ship.' })
    )
);

var PersonalInformation = _wrapComponent('PersonalInformation')((_dec = (0, _reduxForm.reduxForm)({
    form: 'PersonalInformation',
    enableReinitialize: true
}), _dec(_class = (0, _reactIntl.injectIntl)(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(PersonalInformation, _Component);

    function PersonalInformation(props) {
        (0, _classCallCheck3.default)(this, PersonalInformation);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PersonalInformation.__proto__ || (0, _getPrototypeOf2.default)(PersonalInformation)).call(this, props));

        _this.state = {
            commonNameValuePath: undefined,
            travellerHeightValuePath: undefined,
            travellerHeightRenderProps: undefined,
            jacketSizeValuePath: undefined,
            jacketSizeRenderProps: undefined,
            bootsSizeValuePath: undefined,
            bootsSizeRenderProps: undefined
        };
        return _this;
    }

    (0, _createClass3.default)(PersonalInformation, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.initializeStateProps(this.props);
        }
    }, {
        key: 'initializeStateProps',
        value: function initializeStateProps(_ref) {
            var requirementsByCode = _ref.requirementsByCode;

            // Both resources will be initialized (patchHref) if they exist,
            //  and customer id won't change so we only need to do this once at component mount
            var commonNameReq = requirementsByCode.COMMON_NAME;
            if (commonNameReq) {
                this.setState({
                    commonNameValuePath: (0, _forms2.generateValuePath)({
                        requirement: commonNameReq,
                        resourceType: 'customers'
                    })
                });
            }
            var travellerHeightReq = requirementsByCode.TRAVELLER_HEIGHT;
            if (travellerHeightReq) {
                var customerId = travellerHeightReq.customer;
                this.setState({
                    travellerHeightValuePath: (0, _forms2.generateValuePath)({
                        requirement: travellerHeightReq,
                        resourceType: 'departure_services'
                    }),
                    travellerHeightRenderProps: (0, _forms2.objInArrayFieldProps)({
                        findProp: 'customer.id',
                        findValue: customerId,
                        valueProp: 'height',
                        WrappedComponent: _components2.Input
                    })
                });
            }
            var jacketSizeReq = requirementsByCode.JACKET_SIZE;
            if (jacketSizeReq) {
                var _customerId = jacketSizeReq.customer;
                // SHI-1076: Jacket/Parka size is now patched through departure_services
                // (same shape as boots_sizes: [{ customer: { id }, size }]).
                // The old merchandise_services path is kept dormant in serviceSchema /
                // fetchRequirementData for rollback, but must not be used at render time.
                var valuePath = (0, _forms2.generateValuePath)({
                    requirement: jacketSizeReq,
                    resourceType: 'departure_services'
                });
                if (valuePath) {
                    this.setState({
                        jacketSizeValuePath: valuePath,
                        jacketSizeRenderProps: (0, _forms2.objInArrayFieldProps)({
                            findProp: 'customer.id',
                            findValue: _customerId,
                            valueProp: 'size',
                            WrappedComponent: _components2.Input
                        })
                    });
                }
            }
            var bootsSizeReq = requirementsByCode.BOOTS_SIZE;
            if (bootsSizeReq) {
                var _customerId2 = bootsSizeReq.customer;
                this.setState({
                    bootsSizeValuePath: (0, _forms2.generateValuePath)({
                        requirement: bootsSizeReq,
                        resourceType: 'departure_services'
                    }),
                    bootsSizeRenderProps: (0, _forms2.objInArrayFieldProps)({
                        findProp: 'customer.id',
                        findValue: _customerId2,
                        valueProp: 'size',
                        WrappedComponent: _components2.SelectInput
                    })
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                intl = _props.intl,
                initialValues = _props.initialValues,
                hiddenValues = _props.hiddenValues,
                requirementsByCode = _props.requirementsByCode,
                bookingId = _props.bookingId,
                formValues = _props.formValues,
                isFetchingRequirementData = _props.isFetchingRequirementData,
                handleSubmit = _props.handleSubmit,
                error = _props.error,
                invalid = _props.invalid,
                pristine = _props.pristine,
                submitSucceeded = _props.submitSucceeded,
                submitFailed = _props.submitFailed,
                submitting = _props.submitting;


            var contactPrompt = _react3.default.createElement(_components2.DynamicCommunication, { type: 'contactPrompt' });

            var commonNameReq = requirementsByCode.COMMON_NAME;
            var travellerHeightReq = requirementsByCode.TRAVELLER_HEIGHT;
            var jacketSizeReq = requirementsByCode.JACKET_SIZE;
            var bootsSizeReq = requirementsByCode.BOOTS_SIZE;

            // Hide the entire Jacket Size / Parka Size block for pax users
            // when staff has already applied overrides (e.g. "Traveller does not require an Expedition Parka").
            // Staff auth sets isTokenProvided=true via AUTH_TOKEN_PROVIDED (trusted token injection).
            // Pax auth goes through oauth/token login and does not set that flag.
            var isPax = !this.props.isTokenProvided;
            var shouldHideJacketSize = isPax && jacketSizeReq && jacketSizeReq.applied_overrides && jacketSizeReq.applied_overrides.length > 0;

            var jacketSizeOverrideValuePath = jacketSizeReq ? (0, _forms2.generateValuePath)({
                requirement: jacketSizeReq,
                resourceType: 'overrides'
            }) : undefined;
            var jacketSizeOverrideValue = jacketSizeOverrideValuePath ? _lodash2.default.get(formValues, jacketSizeOverrideValuePath + '.reason.code', '') : '';
            var isJacketSizeOverridden = !!jacketSizeOverrideValue;

            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_components2.FormErrorMessage, { errorCode: error, invalid: invalid, submitFailed: submitFailed, submitting: submitting }),
                _react3.default.createElement(
                    'form',
                    null,
                    _react3.default.createElement(_components2.FieldSet, {
                        requirement: commonNameReq,
                        fields: [{
                            id: 'commonName',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formPersonalInformation.commonNameLabel',
                                defaultMessage: 'Common Name' }),
                            field: _react3.default.createElement(_reduxForm.Field, {
                                id: 'commonName',
                                name: this.state.commonNameValuePath + '.name.common_name',
                                hiddenValues: hiddenValues,
                                component: _components2.Input,
                                type: 'text',
                                requirement: commonNameReq,
                                helpText: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formPersonalInformation.commonNameHelpText',
                                    defaultMessage: 'What you\'d like us to call you on your tour.' }) })
                        }, (0, _extends3.default)({}, (0, _forms2.generateOverride)({
                            intl: intl,
                            id: 'commonNameOverride',
                            requirement: commonNameReq,
                            overrideLabels: _forms.formOverrides.personalInformation.COMMON_NAME,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] }),
                    _react3.default.createElement(_components2.FieldSet, {
                        requirement: travellerHeightReq,
                        fields: [{
                            id: 'travellerHeight',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formPersonalInformation.travellerHeightLabel',
                                defaultMessage: 'Traveller Height' }),
                            field: _react3.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                                id: 'travellerHeight',
                                name: this.state.travellerHeightValuePath + '.traveller_heights',
                                hiddenValues: hiddenValues,
                                component: _components2.Input,
                                type: 'number',
                                requirement: travellerHeightReq,
                                helpText: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formPersonalInformation.travellerHeightHelptText',
                                    defaultMessage: 'We require your height in centimetres in order to ensure we can arrange a bike that fits you.' }),
                                parse: function parse(value) {
                                    return parseInt(value);
                                }
                            }, this.state.travellerHeightRenderProps))
                        }] }),
                    jacketSizeReq && this.state.jacketSizeValuePath && !shouldHideJacketSize && _react3.default.createElement(
                        'div',
                        null,
                        _react3.default.createElement(
                            'div',
                            { className: 'grex-FormStubText--info' },
                            jacketSizeInfoBox
                        ),
                        _react3.default.createElement(_components2.FieldSet, {
                            requirement: jacketSizeReq,
                            fields: [{
                                id: 'jacketSize',
                                label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formPersonalInformation.jacketSizeLabel',
                                    defaultMessage: 'Expedition Parka Size' }),
                                field: _react3.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                                    id: 'jacketSize',
                                    name: this.state.jacketSizeValuePath + '.jacket_sizes',
                                    hiddenValues: hiddenValues,
                                    component: _components2.Input,
                                    type: 'select',
                                    options: (0, _keys2.default)(_forms.formOptions.jacketSizeLabels).map(function (key) {
                                        return {
                                            label: intl.formatMessage(_forms.formOptions.jacketSizeLabels[key]),
                                            value: _forms.formOptions.jacketSizeValues[key]
                                        };
                                    }),
                                    requirement: jacketSizeReq,
                                    customDisabled: isJacketSizeOverridden
                                }, this.state.jacketSizeRenderProps))
                            }, (0, _extends3.default)({}, (0, _forms2.generateOverride)({
                                intl: intl,
                                id: 'jacketSizeOverride',
                                requirement: jacketSizeReq,
                                overrideLabels: _forms.formOverrides.personalInformation.JACKET_SIZE,
                                bookingId: bookingId,
                                initialValues: initialValues
                            }))] })
                    ),
                    bootsSizeReq && _react3.default.createElement(
                        'div',
                        null,
                        _react3.default.createElement(
                            'div',
                            { className: 'grex-FormStubText--info' },
                            bootsSizeInfoBox
                        ),
                        _react3.default.createElement(_components2.FieldSet, {
                            requirement: bootsSizeReq,
                            fields: [{
                                id: 'bootsSize',
                                label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formPersonalInformation.bootsSizeLabel',
                                    defaultMessage: 'Boots Size' }),
                                field: _react3.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                                    id: 'bootsSize',
                                    name: this.state.bootsSizeValuePath + '.boots_sizes',
                                    hiddenValues: hiddenValues,
                                    component: _components2.SelectInput,
                                    options: (0, _keys2.default)(_forms.formOptions.bootsSizeLabels).map(function (key) {
                                        return {
                                            label: intl.formatMessage(_forms.formOptions.bootsSizeLabels[key]),
                                            value: _forms.formOptions.bootsSizeValues[key]
                                        };
                                    }),
                                    requirement: bootsSizeReq,
                                    helpText: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'formPersonalInformation.bootsSizeHelpText',
                                        defaultMessage: 'Select your boot size. We recommend sizing up for thick socks.' })
                                }, this.state.bootsSizeRenderProps))
                            }] })
                    ),
                    _react3.default.createElement(_components2.FormSubmit, {
                        handleSubmit: handleSubmit,
                        invalid: invalid,
                        pristine: pristine,
                        submitting: submitting,
                        submitSucceeded: submitSucceeded,
                        isFetchingRequirementData: isFetchingRequirementData })
                )
            );
        }
    }]);
    return PersonalInformation;
}(_react2.Component), _class2.propTypes = {
    intl: _propTypes2.default.object.isRequired,
    initialValues: _propTypes2.default.object.isRequired,
    requirementsByCode: _propTypes2.default.object.isRequired,
    bookingId: _propTypes2.default.string.isRequired,
    isFetchingRequirementData: _propTypes2.default.bool.isRequired,
    handleSubmit: _propTypes2.default.func.isRequired,
    formValues: _propTypes2.default.object,
    error: _propTypes2.default.string,
    invalid: _propTypes2.default.bool,
    pristine: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    submitSucceeded: _propTypes2.default.bool,
    submitFailed: _propTypes2.default.bool
}, _temp)) || _class) || _class));

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        formValues: _lodash2.default.get(state, 'form.PersonalInformation.values', {}),
        isTokenProvided: state.user.isTokenProvided
    };
})(PersonalInformation);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/forms/PersonalInformation.js
// module id = 1325
// module chunks = 0